"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
function IconPlus(_a) {
    var width = _a.width, height = _a.height, className = _a.className;
    return (react_1.default.createElement("svg", { className: "icon ".concat(className), height: "".concat(height), viewBox: "0 0 64 64", width: "".concat(width) },
        react_1.default.createElement("path", { d: "M44.857 28.786h-9.643v-9.643c0-1.139-1.004-2.143-2.143-2.143H30.93c-1.206 0-2.143 1.005-2.143 2.143v9.643h-9.643c-1.206 0-2.143 1.004-2.143 2.143v2.142c0 1.206.938 2.143 2.143 2.143h9.643v9.643c0 1.206.937 2.143 2.143 2.143h2.142c1.139 0 2.143-.938 2.143-2.143v-9.643h9.643c1.139 0 2.143-.937 2.143-2.143V30.93c0-1.139-1.005-2.143-2.143-2.143z", fill: "#000" })));
}
IconPlus.propTypes = {
    width: prop_types_1.default.number,
    height: prop_types_1.default.number,
    className: prop_types_1.default.string,
};
IconPlus.defaultProps = {
    width: 64,
    height: 64,
};
exports.default = IconPlus;
